import React from 'react'
import PrintSingleSlip from '../../Components/Print/PrintSingleSlip'

const Templates = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h3>Templates</h3>
                    </div>

                </div>

                <div className="col-12 mt-3">
                    <div className="oms-table-wrap">
                        <div className="oms-table-header">
                            <div>
                                <span className="oms-table-title">
                                    Templates Records
                                </span>

                            </div>
                        </div>

                        <div style={{ overflowX: "auto" }}>
                            <table>
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Template Name</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>


                                    <tr>
                                        <td>1</td>

                                        <td>
                                            <div className="oms-track-id">
                                                Template 1
                                            </div>
                                        </td>

                                        <td>

                                            <PrintSingleSlip btnText={true} previewId={1} />
                                            <div className="col-auto">

                                            </div>
                                        </td>


                                    </tr>
                                    <tr>
                                        <td>2</td>

                                        <td>
                                            <div className="oms-track-id">
                                                Template 2
                                            </div>
                                        </td>

                                        <td>
                                            <PrintSingleSlip btnText={true} previewId={2} />

                                        </td>


                                    </tr>
                                    <tr>
                                        <td>3</td>

                                        <td>
                                            <div className="oms-track-id">
                                                Template 3
                                            </div>
                                        </td>

                                        <td>
                                            <PrintSingleSlip btnText={true} previewId={3} />

                                        </td>


                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default Templates